import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import EntityTableProvider from '../entity-table-provider/entity-table-provider.vue';
import ExportModal from '@shared/components/modals/export-modal/export-modal.vue';
import AsyncExportModal from '@shared/components/modals/export-modal/async-export-modal.vue';

@Component({
  components: {
    'bpc-export-modal': ExportModal,
    'bpc-async-export-modal': AsyncExportModal,
  },
})
export default class TableExportsToCSV extends Vue {
  declare $refs: {
    provider: InstanceType<typeof EntityTableProvider> & {
      export(): Promise<void>;
      exportAll(): Promise<void>;
      exportCancel(): Promise<void>;
      downloadingExport: boolean;
    };
  };

  @Prop({ type: Boolean, default: false }) readonly emitOnExport: boolean;

  isExportingTable = false;
  entityName;
  showExportModal: boolean = false;
  downloadingExport: boolean = false;
  downloadingExportAll: boolean = false;
  exportConfigName = 'export';
  exportMaxLimit = 200;

  // It will be overwritten in the abstract table
  get pageActions() {
    return {};
  }

  get exportAllAllowed(): boolean {
    return !!this.pageActions?.['exportAll']?.['activated'];
  }

  beforeMount() {
    // NOTE: in some estrange cases the entityName is not present
    if (this.entityName) {
      const exportMaxLimitPath = `${this.entityName}.displays.${this.exportConfigName}.exportMaxLimit`;
      this.$bpcConfig.getEntityConfig(exportMaxLimitPath).subscribe(res => {
        const configExportMaxLimitValue = parseInt(res.data);
        if (configExportMaxLimitValue) {
          this.exportMaxLimit = configExportMaxLimitValue;
        }
      });
    }
  }

  async onExport() {
    if (!this.emitOnExport) {
      this.openExportConfirmModal();
    } else {
      this.$emit('on-export');
    }
  }

  openExportConfirmModal() {
    this.showExportModal = true;
  }

  async closeExportConfirmModal() {
    await this.$refs.provider.exportCancel();
    this.downloadingExport = false;
    this.downloadingExportAll = false;
    this.showExportModal = false;
  }

  closeAsyncExportConfirmModal() {
    this.showExportModal = false;
  }

  async onConfirmExport() {
    this.downloadingExport = true;
    await this.$refs.provider.export();
    this.closeExportConfirmModal();
    this.downloadingExport = false;
  }
  async onConfirmExportAll() {
    this.downloadingExportAll = true;
    await this.$refs.provider.exportAll();
    this.closeExportConfirmModal();
    this.downloadingExportAll = false;
  }

  public exportReportDataToShow = [['id', 'code']];
}
